import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TAppointmentTemplate } from '@shared/types/appointment-template';
import type { TBaseQuery } from '@shared/types/base-query';

export type TAppointmentTemplateQuery = {
  interview_type?: TAppointmentTemplate['interview_type'];
  type?: TAppointmentTemplate['type'];
} & TBaseQuery;

type TMeetingTemplatePayload = {
  name: string;
  description: string;
  type: TAppointmentTemplate['type'];
  interview_type: TAppointmentTemplate['interview_type'];
};

const meetingTemplateApi = createCrudService<
  TAppointmentTemplate,
  TAppointmentTemplateQuery,
  TMeetingTemplatePayload
>({
  queryKey: [QUERY_KEYS.getAppointmentTemplates],
  url: 'meeting-templates',
});

export default meetingTemplateApi;
